import { ChangeDetectionStrategy, Component, EventEmitter, Output } from "@angular/core";
import { Accordion } from "primeng/accordion";

@Component({
  selector: "app-accordion-panel-custom",
  template: `
  <p-accordion (onOpen)="onTabOpen($event);" class="app-accordion" #customAccordionPanel>
    <ng-content></ng-content>
  </p-accordion>
`,
  styleUrls: ["./accordion-panel-custom.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [Accordion],
})
export class AccordionPanelCustomComponent {
  @Output() onOpen = new EventEmitter<any>();

  onTabOpen(event: any) {
    this.onOpen.emit(event);
  }
}
